import applicability from "@/components/common/icons/applicability";
import quicktree from "@/components/common/icons/quicktree";
import checkout from "@/components/common/icons/checkout";
import pencil from "@/components/common/icons/pencil";
import trash from "@/components/common/icons/trash";
import calculator from "@/components/common/icons/calculator";
import home from "@/components/common/icons/home";
import search from "@/components/common/icons/search";
import save from "@/components/common/icons/save";
import car_plus from "@/components/common/icons/car_plus";
import cart from "@/components/common/icons/cart";
import user from "@/components/common/icons/user";
import telegram from "@/components/common/icons/telegram";
import calendar from "@/components/common/icons/calendar";
import suppliers from "@/components/common/icons/suppliers";
import sync from "@/components/common/icons/sync";
import customers from "@/components/common/icons/customers";
import garage from "@/components/common/icons/garage";
import storage from "@/components/common/icons/storage";
import settings from "@/components/common/icons/settings";
import works from "@/components/common/icons/works";
import partcode from "@/components/common/icons/partcode";
import oem from "@/components/common/icons/oem";
import aftermarket from "@/components/common/icons/aftermarket";
import catalog_maintenance from "@/components/common/icons/catalog_maintenance";
import accessories from "@/components/common/icons/accessories";
import batteries from "@/components/common/icons/batteries";
import oils from "@/components/common/icons/oils";
import lamps from "@/components/common/icons/lamps";
import bolts from "@/components/common/icons/bolts";
import wheels from "@/components/common/icons/wheels";
import tires from "@/components/common/icons/tires";
import caps from "@/components/common/icons/caps";
import check from "@/components/common/icons/check";
import cross from "@/components/common/icons/cross";
import logout from "@/components/common/icons/logout";
import plus from "@/components/common/icons/plus";
import tools from "@/components/common/icons/tools";
import gear_tools from "@/components/common/icons/gear_tools";
import xlsx from "@/components/common/icons/xlsx";
import upload from "@/components/common/icons/upload";
import download from "@/components/common/icons/download";
import checklist from "@/components/common/icons/checklist";
import history from "@/components/common/icons/history";
import picture from "@/components/common/icons/picture";
import brake1 from "@/components/common/icons/brake1";
import brake2 from "@/components/common/icons/brake2";
import filters from "@/components/common/icons/filters";
import engine from "@/components/common/icons/engine";
import belts from "@/components/common/icons/belts";
import windscreen_cleaning_system from "@/components/common/icons/windscreen_cleaning_system";
import fluids from "@/components/common/icons/fluids";
import analytics from "@/components/common/icons/analytics";
import slideshow from "@/components/common/icons/slideshow";
import zzap from "@/components/common/icons/zzap";
import document from "@/components/common/icons/document";
import mobile_phone from "@/components/common/icons/mobile_phone";
import bids from "@/components/common/icons/bids";
import avito from "@/components/common/icons/avito";
import ozon from "@/components/common/icons/ozon";

export default {
  ozon: { component: ozon },
  bids: { component: bids },
  zzap: { component: zzap },
  avito: { component: avito },
  quicktree: { component: quicktree },
  checkout: { component: checkout },
  pencil: { component: pencil },
  trash: { component: trash },
  calculator: { component: calculator },
  home: { component: home },
  search: { component: search },
  save: { component: save },
  cart: { component: cart },
  user: { component: user },
  calendar: { component: calendar },
  suppliers: { component: suppliers },
  sync: { component: sync },
  customers: { component: customers },
  garage: { component: garage },
  storage: { component: storage },
  settings: { component: settings },
  works: { component: works },
  partcode: { component: partcode },
  oem: { component: oem },
  aftermarket: { component: aftermarket },
  catalog_maintenance: { component: catalog_maintenance },
  accessories: { component: accessories },
  batteries: { component: batteries },
  oils: { component: oils },
  lamps: { component: lamps },
  bolts: { component: bolts },
  wheels: { component: wheels },
  tires: { component: tires },
  caps: { component: caps },
  check: { component: check },
  cross: { component: cross },
  telegram: { component: telegram },
  logout: { component: logout },
  plus: { component: plus },
  tools: { component: tools },
  gear_tools: { component: gear_tools },
  xlsx: { component: xlsx },
  upload: { component: upload },
  download: { component: download },
  checklist: { component: checklist },
  history: { component: history },
  picture: { component: picture },
  brake1: { component: brake1 },
  brake2: { component: brake2 },
  filters: { component: filters },
  engine: { component: engine },
  belts: { component: belts },
  windscreen_cleaning_system: { component: windscreen_cleaning_system },
  fluids: { component: fluids },
  analytics: { component: analytics },
  slideshow: { component: slideshow },
  document: { component: document },
  mobile_phone: { component: mobile_phone },
  applicability: { component: applicability },
  car_plus: { component: car_plus },
};
